import Hotel from "@website/icons/components/hotel";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Loading } from "@website/ui/loading";
import { TextField } from "@website/ui/text-field";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { FC } from "react";

import styles from "@website/widget/login/components/b2b-inquiry/b2b-inquiry.module.scss";
import { B2BInquiryPropertiesTypes } from "@website/widget/login/components/b2b-inquiry/types";
import { useB2BInquiry } from "@website/widget/login/components/b2b-inquiry/use-b2b-inquiry";

export const B2BInquiry: FC<B2BInquiryPropertiesTypes> = (properties) => {
  const {
    phoneNumber,
    contractId,
    onChangePhoneNumber,
    onChangeContractId,
    onSubmitPhoneNumber,
    isLoading,
    error
  } = useB2BInquiry(properties);

  return (
    <div className={styles["container"]}>
      <div className={styles["title"]}>
        لطفا برای ورود اطلاعات زیر را وارد کنید.
      </div>
      <form onSubmit={isLoading ? undefined : onSubmitPhoneNumber}>
        <div className={styles["input"]}>
          <TextField
            StartIcon={<Hotel width={18} />}
            error={Boolean(error)}
            fullWidth
            onChange={onChangeContractId}
            placeholder="کد شرکت"
            value={contractId}
          />
          <TextField
            StartIcon={<MaterialIcon name="phone_iphone" />}
            error={Boolean(error)}
            fullWidth
            onChange={onChangePhoneNumber}
            placeholder="شماره موبایل"
            value={phoneNumber}
          />
        </div>
        {error && (
          <div className={styles["info"]}>
            <span className={styles["info-icon"]}>
              <MaterialIcon name="info" variant="outlined" />
            </span>
            {error}
          </div>
        )}
        <div className={styles["footer"]}>
          <Button
            color="secondary"
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            {isLoading ? (
              <Loading color="white" size="lg" />
            ) : (
              replaceSnappTripBasedOnChannel("تایید و ورود به اسنپ‌تریپ!")
            )}
          </Button>
        </div>
      </form>
    </div>
  );
};
